<input #inputEl type="text" class="form-control" inputmode="decimal" [ngClass]="{ 'text-end': textEnd }" [disabled]="disabled"
       [attr.placeholder]="disabled? '' : placeholder"/>
<div *ngIf="limitHint" class="text-warning small mt-1" role="alert" aria-live="polite">
  {{ limitHint }}
</div>
